import { getSessionVertical } from '../utils/authStorage';
import { resolveReturnTo } from './returnTo';

/**
 * Module-home back arrow policy:
 * - Management users: show back (they browse across verticals).
 * - Vertical-native users on their own home: hide back (this page is their home).
 * - Anyone with an explicit returnTo: show back (came from a drill-down).
 *
 * @param {string} homeVertical - e.g. 'sales' | 'operations' | 'inventory' | 'marketing' | 'accounts'
 * @param {object} [location] - react-router location (optional)
 */
export function shouldShowModuleHomeBack(homeVertical, location) {
  if (location && resolveReturnTo(location)) return true;

  const session = getSessionVertical();
  if (!session) return false;
  if (session === 'management') return true;

  const home = String(homeVertical || '')
    .trim()
    .toLowerCase();
  if (!home) return session === 'management';

  return session !== home;
}

/**
 * Where a self-service page (My Leave, My Payslips, My Policies) goes back to
 * when there is no page to return to: the signed-in user's own home, the same
 * place login sends them. Every vertical can open these pages, and the
 * dashboard is not a home for all of them — HR has none, so a fixed
 * '/builder/dashboard' left HR on a blank screen.
 */
export function selfServiceHomePath(vertical = getSessionVertical()) {
  switch (String(vertical || '').toLowerCase()) {
    case 'hr':
      return '/builder/workforce?tab=employees';
    case 'sales':
      return '/builder/sales';
    case 'accounts':
      return '/builder/reports';
    case 'legal':
      return '/builder/legal';
    default:
      return '/builder/dashboard';
  }
}
